import {
  FETCH_BUSSINESS_TYPES_SUCCESS,
  FETCH_BUSINESS_TYPES_ERROR,
  FETCH_BUSINESS_TYPES_URL,
  ON_CHANGE,
  ON_VALIDATION_ERRORS,
  ON_SUBMIT,
  ON_SUBMIT_FAILURE,
  ON_SUBMIT_SUCCESS,
} from './constants';
import safeFetch from './helpers/safe-fetch';
import { ValidationErrors, DraftServiceResponse, ListOfPds, AsyncActionCreator } from './types';

export function onChange(data: Object) {
  return {
    type: ON_CHANGE,
    data,
  };
}

export function fetchBusinessTypesSuccess(data: ListOfPds[]) {
  return {
    type: FETCH_BUSSINESS_TYPES_SUCCESS,
    data,
  };
}

export function fetchBusinessTypesFailure(data: Object) {
  return {
    type: FETCH_BUSINESS_TYPES_ERROR,
    data,
  };
}

export function showErrors(errors: ValidationErrors) {
  return {
    type: ON_VALIDATION_ERRORS,
    data: {
      validations: errors,
    },
  };
}

export function onSubmitSuccess(res: DraftServiceResponse) {
  return {
    type: ON_SUBMIT_SUCCESS,
    data: res,
  };
}

export function onSubmit() {
  return {
    type: ON_SUBMIT,
  };
}

export function onSubmitFailure() {
  return {
    type: ON_SUBMIT_FAILURE,
  };
}

// API call for all category data
export const fetchBusinessTypes = (): AsyncActionCreator => async dispatch => {
  try {
    const response = await safeFetch(FETCH_BUSINESS_TYPES_URL, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'x-csrf-token': window.csrf_token,
      },
    });
    dispatch(fetchBusinessTypesSuccess(response));
  } catch {
    dispatch(fetchBusinessTypesFailure(true));
  }
};
